import { InferRequestType, InferResponseType } from "hono";
import { useMutation } from "react-query";

import { useHonoClient } from "~/hooks/HonoContext";
import { useAccountStore } from "~/stores/space";

export const useUploadObject = () => {
  const { hc } = useHonoClient();
  const objectPut = hc.accounts[":accountId"].object.$put;
  const { store } = useAccountStore();
  const { mutateAsync, ...rest } = useMutation<
    InferResponseType<typeof objectPut>,
    unknown,
    InferRequestType<typeof objectPut>["json"]
  >((data) => {
    return objectPut({
      json: data,
      param: {
        accountId: store.id,
      },
    }).then((res) => res.json());
  });

  return {
    uploadObject: mutateAsync,
    ...rest,
  };
};
